interface LogoMarkProps {
  size?: number;
}

export function LogoMark({ size = 48 }: LogoMarkProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width={size}
      height={size}
      aria-label="Assine"
      role="img"
    >
      <rect x="3" y="22" width="9" height="22" rx="4.5" fill="#A855F7" />
      <rect x="15" y="14" width="9" height="30" rx="4.5" fill="#E84393" />
      <rect x="27" y="6" width="9" height="38" rx="4.5" fill="#FF6B6B" />
      <path
        d="M40 16 L43 10 L46 16"
        stroke="#FF8E53"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1="43"
        y1="10"
        x2="43"
        y2="22"
        stroke="#FF8E53"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
